import {
  isMobileOnly,
  isTablet,
} from 'react-device-detect';
import uuid from 'uuid';
import { MEDIA_TYPE_IS_ARTICLE, MEDIA_TYPE_IS_VIDEO } from '../app-constants';
import generateYoutubeUrlPrefix from './general-utilities';

const deployEnv = () => {
  const location = window.location.href;
  if (location.indexOf('dev') >= 0) return 'dev';
  if (location.indexOf('stage') >= 0) return 'uat';
  if (location.indexOf('www.telstra.com.au') >= 0) return 'production';
  return '';
};

export const sysEnv = (mobile, tablet) => {
  if (mobile) return 'mobile';
  if (tablet) return 'tablet';
  return 'desktop';
};

const eventName = 'vantage-2018';

export const omnitureTriggerEventAction = (action) => {
  const event = {
    eventInfo: {
      eventAction: action,
    },
  };
  window.digitalData.event.push(event);
};

export const omnitureTriggerComponentAction = ({ id, title, buttonText, summary, index, mediaType, url, meta }) => {
  let componentID;
  let destination;
  if (id) {
    componentID = (mediaType && mediaType === MEDIA_TYPE_IS_VIDEO) ? `ytv_${id}` : `component_${id}`;
    destination = (mediaType && mediaType === MEDIA_TYPE_IS_VIDEO) && `${generateYoutubeUrlPrefix(id)}`;
  } else {
    componentID = `component_${uuid()}`;
  }
  if (url) {
    destination = url;
  }
  window.digitalData.components.push({
    componentInfo: {
      componentID, // youtube ID eg: video_0ijhTlYPfKU REQUIRED - could be UUID random on page session if needed
      // this will be required for the carousel items that don't necessarily have unique ids
      title: title || meta, // name of video or article eg: Internet of Things
      name: componentID, // eg: video_0ijhTlYPfKU
      ctaText: buttonText, // eg: 'Watch Video'
      displayedText: summary, // summary/description
      linkText: mediaType === MEDIA_TYPE_IS_ARTICLE ? buttonText : '', // Read more (articles only)
      position: index !== undefined ? index + 1 : '', // index + 1 of the video or article (not zero based)
      destination, // url of video or article url
    },
  });
};

export const omnitureTriggerError = (error) => {
  const errorMessage = {
    errorCode: error,
    type: 'Technical',
  };
  window.digitalData.page.errorMessage.push(errorMessage);
};

export const createOmnitureDataLayer = (pageType, uId) => {
  window.digitalData.page = {
    pageInfo: {
      pageName: `events:${eventName}`,
      destinationURL: window.location.href,
      referringURL: document.referrer,
      deployEnv: deployEnv(),
      variant: pageType,
      sysEnv: sysEnv(isMobileOnly, isTablet),
    },
    category: {
      primaryCategory: 'my-business-solution',
      secondaryCategory: 'events',
      tertiaryCategory: eventName,
    },
    errorMessage: [],
  };

  window.digitalData.user[0] = {
    profile: [
      {
        profileInfo: {
          purlId: uId,
        },
      },
    ],
  };

  window.digitalData.components = [];
};

export const createOmnitureDataLayerForSSM = (pageType, tertiaryCategoryValue) => {
  window.digitalData.page = {
    pageInfo: {
      pageName: 'CustomNet',
      destinationURL: window.location.href,
      referringURL: document.referrer,
      deployEnv: deployEnv(),
      variant: pageType,
      sysEnv: sysEnv(isMobileOnly, isTablet),
    },
    category: {
      primaryCategory: 'my-business-solution',
      secondaryCategory: 'CustomNet',
      tertiaryCategory: tertiaryCategoryValue,
      errorMessage: [],
    },
    attributes: {
      division: 'TD',
      subDivision: 'TDE',
      subDivisionUnit: 'TBE',
    },
  };

  window.digitalData.components = [];
};

export const omnitureTriggerComponentActionForSSM = ({ id, buttonText }) => {
  const componentID = `component_${uuid()}`;
  window.digitalData.components.push({
    componentInfo: {
      componentID,
      title: id,
      name: componentID,
      ctaText: buttonText,
    },
  });
};


export const createOmnitureDataLayerForApps = (pageType, primaryCategoryValue, secondaryCategoryValue, tertiaryCategoryValue) => {
  window.digitalData.page = {
    pageInfo: {
      pageName: 'AdaptiveMobilityExternal',
      destinationURL: window.location.href,
      referringURL: document.referrer,
      deployEnv: deployEnv(),
      variant: pageType,
      sysEnv: sysEnv(isMobileOnly, isTablet),
    },
    category: {
      primaryCategory: primaryCategoryValue,
      secondaryCategory: secondaryCategoryValue,
      tertiaryCategory: tertiaryCategoryValue,
      errorMessage: [],
    },
    attributes: {
      division: 'TD',
      subDivision: 'TDE',
      subDivisionUnit: 'TBE',
    },
  };

  window.digitalData.components = [];
};
